import { MasterRegionBasicInfo } from 'pages/Map/types';
import { Dispatch, SetStateAction } from 'react';

export const enum PAGE {
    REGION_SELECTION = 'region_selection',
    MAP_SELECTION = 'map_selection',
    ZONE_SELECTION = 'zone_selection'
}

export type Zone = {
    name: string;
    type: string;
};

export type MapInfo = {
    mapName?: string;
    region?: MasterRegionBasicInfo;
    zone?: Zone;
};

export type CapturingMapContextType = {
    currentStep: PAGE;
    setCurrentStep: Dispatch<SetStateAction<PAGE>>;
    mapInfo: MapInfo;
    setMapInfo: Dispatch<SetStateAction<MapInfo>>;
};
